/**
 * Knowledge-API host configuration.
 *
 * Apps using @arkturian/audio-guide can override the default host via
 * configureKnowledgeBase() at boot. Same pattern as configureStorageBase
 * — keeps the library reusable across deployments (Tschepp's
 * recommendation 2026-06-04).
 *
 * Default = arkturian. Apps that want a different host (staging,
 * locally-running knowledge-api, or a non-Tschepp deployment with
 * its own knowledge backend) call configureKnowledgeBase(url) once
 * before any KnowledgeView mount.
 */
let _knowledgeBase = 'https://knowledge-api.arkturian.com';
/**
 * Override the Knowledge-API base URL used by KnowledgeView for
 * species lookups. Default targets arkturian; call at app boot to
 * point at a different host.
 *
 *   configureKnowledgeBase('https://knowledge.staging.example.com');
 *   configureKnowledgeBase('http://localhost:8090');
 */
export function configureKnowledgeBase(url) {
    _knowledgeBase = url.replace(/\/+$/, '');
}
/** Current Knowledge-API base URL. Returned without trailing slash. */
export function getKnowledgeBase() {
    return _knowledgeBase;
}
//# sourceMappingURL=knowledgeBase.js.map